// Persist-стор ширины правых боковых панелей (репетитор + уведомления).
// Обе панели читают одну ширину — паритет (frontend-ui.md §13: одинаковая
// геометрия панелей оболочки). Пользователь тянет за левую границу панели
// (PanelResizeHandle) → setWidth. Значение переживает reload (frontend-state.md
// §2: layout-предпочтение = user-pref). Эфемерных производных тут нет —
// храним один источник истины (width).
import { create } from "zustand";
import { persist } from "zustand/middleware";

/**
 * Минимальная / максимальная ширина панели (px).
 *
 * MIN — это ещё и ширина, до которой панель ужимается САМА на узком desktop
 * (`components/layout/_panel-geometry.ts`): ниже неё чат репетитора перестаёт
 * быть чатом. Поэтому константа экспортируется, а не живёт локальной.
 */
export const SIDE_PANEL_MIN_WIDTH = 320;
export const SIDE_PANEL_MAX_WIDTH = 720;
/** Дефолтная ширина = историческое 400px. */
export const SIDE_PANEL_DEFAULT_WIDTH = 400;

function clampWidth(value: number): number {
	if (Number.isNaN(value)) return SIDE_PANEL_DEFAULT_WIDTH;
	return Math.min(SIDE_PANEL_MAX_WIDTH, Math.max(SIDE_PANEL_MIN_WIDTH, Math.round(value)));
}

interface SidePanelWidthState {
	/** Ширина правой боковой панели в px (общая для tutor + notifications). */
	width: number;
	setWidth: (w: number) => void;
	/** Сброс на дефолт (двойной клик по разделителю). */
	resetWidth: () => void;
}

export const useSidePanelWidthStore = create<SidePanelWidthState>()(
	persist(
		(set) => ({
			width: SIDE_PANEL_DEFAULT_WIDTH,
			setWidth: (w) => set({ width: clampWidth(w) }),
			resetWidth: () => set({ width: SIDE_PANEL_DEFAULT_WIDTH }),
		}),
		{
			name: "studyhub:side-panel-width",
			// partialize обязателен — сохраняем только источник истины (width).
			partialize: (state) => ({ width: state.width }),
		},
	),
);
